{
  "version": 1,
  "asset_id": "879c9d18-fb07-466d-9ec7-2636036422db",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/879c9d18-fb07-466d-9ec7-2636036422db/destination-roofing-blue-metal-roof-lecanto-fl-1320w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/879c9d18-fb07-466d-9ec7-2636036422db/destination-roofing-blue-metal-roof-lecanto-fl-1320w.webp",
  "original_filename": "destination-roofing-blue-metal-roof-lecanto-fl-1320w.webp",
  "size": 137870,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:37:12Z"
}
